import { HttpParams, HttpResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    FilterSearchingCodigoConfeccionImportacionViewModel,
    CodigoConfeccionImportacionViewModel,
    CodigoConfeccionImportacionItemResultsViewModel,
} from './registrosanitario.types';

@Injectable()
export class RegistroSanitarioService {
    registroSanitarioEndpoint = this.baseUrl + 'api/importacion/codigoconfeccionimportacion/';
    private lastSearch?: FilterSearchingCodigoConfeccionImportacionViewModel;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    private convertModelToHttpParms(payload: FilterSearchingCodigoConfeccionImportacionViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingCodigoConfeccionImportacionViewModel;

        for (k in payload) {
            let v;
            let valor = payload[k];
            if (k == 'Activo' && valor == 0) {
                v = 0;
            } else {
                v = payload[k] || '';
            }

            params = params.append(k, v);
        }

        return params;
    }

    getRegistrosSanitarios(payload: FilterSearchingCodigoConfeccionImportacionViewModel): Observable<CodigoConfeccionImportacionItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getRegistrosSanitariosPagedByFilter(params);
    }

    getRegistrosSanitariosPagedByFilter(params: HttpParams): Observable<CodigoConfeccionImportacionItemResultsViewModel> {
        console.log(params);
        return this.http.get<CodigoConfeccionImportacionItemResultsViewModel>(this.registroSanitarioEndpoint + 'pagedbyfilter/', { params: params });
    }

    getRegistroSanitarioById(id: number): Observable<CodigoConfeccionImportacionViewModel> {
        return this.http.get<CodigoConfeccionImportacionViewModel>(this.registroSanitarioEndpoint + 'getCodigoConfeccionImportacionById/' + id);
    }

    saveRegistroSanitario(registroSanitario: CodigoConfeccionImportacionViewModel): Observable<any> {
        if (registroSanitario?.Id) {
            return this.editRegistroSanitario(registroSanitario);
        }
        return this.createRegistroSanitario(registroSanitario);
    }

    createRegistroSanitario(registroSanitario: CodigoConfeccionImportacionViewModel): Observable<any> {
        return this.http.post<CodigoConfeccionImportacionViewModel>(this.registroSanitarioEndpoint, registroSanitario);
    }

    editRegistroSanitario(registroSanitario: CodigoConfeccionImportacionViewModel): Observable<any> {
        return this.http.put<CodigoConfeccionImportacionViewModel>(this.registroSanitarioEndpoint, registroSanitario);
    }

    deleteRegistroSanitario(id: number): Observable<any> {
        return this.http.delete<CodigoConfeccionImportacionViewModel>(this.registroSanitarioEndpoint + id);
    }

    exportRegistrosSanitarios(model: FilterSearchingCodigoConfeccionImportacionViewModel): Observable<HttpResponse<Blob>> {
        return this.http.post(this.registroSanitarioEndpoint + 'postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' });
    }

    getLastSearch(): FilterSearchingCodigoConfeccionImportacionViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }
}
